import Footer from "../../component/Footer";
import { useState, useEffect } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { useNavigate } from "react-router-dom";
import RechargeNavbar from "./AgentComp/RechargeNavbar";
import axios from "axios";
import { baseurl } from "../../component/Baseurl"; // Importing baseurl
import Swal from "sweetalert2";


function RechargeDth() {
  const [subscriberId, setSubscriberId] = useState("");
  const [operator, setOperator] = useState("");
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();
  const [operators, setOperators] = useState([]);
  const [selectedOperator, setSelectedOperator] = useState(""); 

   // Fetch Operators List using Axios
   useEffect(() => {
    const fetchOperatorsList = async () => {
      try {
        const response = await axios.get(`${baseurl}checkServiceList`);
        
        if (response.data?.data?.data) {
          setOperators(response.data.data.data);
        } else {
          console.error("Invalid response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching operators list:", error);
      }
    };

    fetchOperatorsList();
  }, []);



  const handleSubmit = async (e) => {
    e.preventDefault(); 
  
    if (!/^[0-9]{10,15}$/.test(subscriberId)) {
      alert("Please enter a valid Subscriber ID (10-15 digits).");
      return;
    }
  
    if (!amount || parseFloat(amount) <= 0) {
      alert("Please enter a valid recharge amount.");
      return;
    }
  
    if (!selectedOperator) {
      alert("Please select a DTH operator.");
      return;
    }
  
    // Prepare data payload
    const rechargeData = {
      subscriberId,
      operator: selectedOperator,
      amount,
    };
  
    console.log("📤 Sending Data:", rechargeData); // Log data before sending
  
    // Show SweetAlert confirmation
    const result = await Swal.fire({
      title: "Confirm Recharge",
      html: `<b>Subscriber ID:</b> ${subscriberId} <br> 
             <b>Operator:</b> ${selectedOperator} <br> 
             <b>Amount:</b> ₹${amount}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "Cancel",
    });
  
    if (!result.isConfirmed) {
      console.log("🚫 Recharge Cancelled by User");
      return;
    }
  
    // Proceed with API request if confirmed
    try {
      const response = await axios.post(`${baseurl}dthRecharge`, rechargeData, {
        headers: { "Content-Type": "application/json" },
      });
  
      console.log("✅ Response:", response.data); // Log response from the backend
  
      // Show success message
      Swal.fire("Success!", "DTH Recharge Request Sent!", "success");
  
      // Optionally, navigate after successful submission
      // navigate(`/dth-recharge-confirmation?transactionId=${response.data.transactionId}`);
    } catch (error) {
      console.error("❌ Error:", error.response?.data || error.message);
      Swal.fire("Error!", "Something went wrong!", "error");
    }
  };
  
  

  return (
    <>
      <AgentNavbar />
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <RechargeNavbar />
          <h1 className="text-start agenth1 font3 txt6">DTH Recharge</h1>
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              
              {/* Subscriber ID */}
              <div className="col-md-6 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Subscriber ID/ Mobile Number</label>
                <input
                  type="tel"
                  className="input2"
                  name="subscriberId"
                  placeholder="Enter DTH Subscriber ID"
                  value={subscriberId}
                  onChange={(e) => setSubscriberId(e.target.value)}
                  required
                />
              </div>

              {/* Operator Selection */}
              <div className="col-md-6 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">DTH Operator</label>
                <select
                  className="input2"
                  value={selectedOperator}
                  onChange={(e) => setSelectedOperator(e.target.value)}
                  required
                >
                  <option value="">-- Select Operator --</option>
                  {operators.map((operator) => (
                    <option key={operator.service_id} value={operator.service_code}>
                      {operator.service_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Recharge Amount */}
              <div className="col-md-6 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Recharge Amount</label>
                <input
                  type="number"
                  className="input2"
                  name="amount"
                  placeholder="Enter Recharge Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                />
              </div>

            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">
                Proceed to Recharge
              </button>
            </div>
          </form>

          <hr className="mt-4" />
          <p>Enter your DTH subscriber details to proceed with a seamless recharge.</p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RechargeDth;
